module.exports = __webpack_public_path__ + "static/img/200139.d27815dc.png";